<template>
  <div class="sp-spacer"></div>
</template>

<style>
:host {
  flex-grow: 1;
}
</style>
